import { Flex } from "@chakra-ui/react/flex";
import { useBreakpointValue } from "@chakra-ui/react/hooks";
import { Spinner } from "@chakra-ui/react/spinner";
import React, { Suspense } from "react";

interface RouteSuspenseProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const RouteSuspense: React.FC<RouteSuspenseProps> = ({
  children,
  fallback,
}) => {
  const isBaseSize = useBreakpointValue(
    { base: true, md: false },
    { ssr: false }
  );

  const defaultFallback = (
    <Flex
      flex={1}
      w="100%"
      h="100%"
      overflowY="hidden"
      justifyContent="center"
      alignItems="center"
    >
      <Spinner size="xl" />
    </Flex>
  );

  return <Suspense fallback={fallback ?? defaultFallback}>{children}</Suspense>;
};

export default RouteSuspense;
